import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={43} height={43} fill="#00AAEC" rx={3} />
      <path
        fill="#FFF"
        d="M32 14.973a8.015 8.015 0 0 1-2.356.662 4.198 4.198 0 0 0 1.804-2.327 8.081 8.081 0 0 1-2.607 1.02A4.047 4.047 0 0 0 25.846 13c-2.264 0-4.101 1.884-4.101 4.207 0 .33.035.65.105.959-3.41-.176-6.433-1.85-8.458-4.398a4.284 4.284 0 0 0-.555 2.118c0 1.459.724 2.747 1.825 3.501a4.029 4.029 0 0 1-1.859-.524v.051c0 2.04 1.415 3.74 3.293 4.126a3.913 3.913 0 0 1-1.081.148c-.265 0-.523-.025-.773-.075.523 1.671 2.037 2.888 3.833 2.92A8.102 8.102 0 0 1 12 27.779a11.424 11.424 0 0 0 6.29 1.889c7.548 0 11.674-6.41 11.674-11.971 0-.183-.003-.366-.01-.545A8.421 8.421 0 0 0 32 14.973"
      />
    </g>
  </svg>
);
export default SvgTwitter;
